// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar_root__1LUlK","row":"Navbar_row__3HRwL","section":"Navbar_section__14gBo","active":"Navbar_active__14Z5Y"};